import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calculateSummary',
  standalone: true,
})
export class CalculateSummaryPipe implements PipeTransform {
  transform(balance: any, estimated = false, estimatedCurrency: string): any {
    let result: number;
    if (estimated) {
      result = parseFloat(balance[estimatedCurrency]);
    } else {
      result = parseFloat(balance);
    }
    return result;
  }
}
